<template>
  <div id="App">
    <!-- <router-link to="/login">Home</router-link> -->
    <router-view v-whchat-title="$route.meta.title" />
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style lang="scss">
  .el-scrollbar {
    .el-scrollbar__bar {
      opacity: 1 !important;
    }
  }
</style>
